var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "sc-report-total-quote__content" },
    [
      _c(
        "sc-field",
        { attrs: { label: "Datas (máximo de 30 dias)" } },
        [
          _c("sc-range-date-picker", {
            staticClass: "inner-content__date-picker",
            attrs: { "max-date": _vm.maxDate, format: _vm.formatDateRange },
            model: {
              value: _vm.dateRange,
              callback: function($$v) {
                _vm.dateRange = $$v
              },
              expression: "dateRange"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "sc-field",
        { attrs: { label: "Tipo de Relatório" } },
        [
          _c(
            "sc-select",
            {
              attrs: { placeholder: "Selecione" },
              model: {
                value: _vm.selectedMethod,
                callback: function($$v) {
                  _vm.selectedMethod = $$v
                },
                expression: "selectedMethod"
              }
            },
            _vm._l(_vm.reports, function(report) {
              return _c(
                "option",
                { key: report.value, domProps: { value: report.value } },
                [_vm._v("\n        " + _vm._s(report.label) + "\n      ")]
              )
            })
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "sc-report-total-quote__buttons" },
        [
          _c(
            "button",
            {
              staticClass: "button is-primary sc-report-total-quote__button",
              class: { "is-loading": _vm.loading },
              attrs: { disabled: !_vm.selectedMethod },
              on: { click: _vm.generateReport }
            },
            [_vm._v("\n      Gerar relatório\n    ")]
          ),
          _vm._v(" "),
          _vm.hasGeneratedReport
            ? _c(
                "router-link",
                {
                  staticClass:
                    "button is-default sc-report-total-quote__button",
                  attrs: {
                    to: { name: "files-reports", params: { type: "xlsx" } }
                  }
                },
                [_vm._v("\n      Ir para Meus arquivos\n    ")]
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-dca8a7c4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dca8a7c4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./node_modules/@intelipost-modules/secure-analytic/features/reports/pages/total-quote/ReportTotalQuote.vue
// module id = null
// module chunks = 